import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator as MatPaginator } from '@angular/material/paginator';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';

import { ReviewsService } from 'src/app/e-commerce/common/reviews/reviews.service';

@Component({
  selector: 'app-most-reviewed.',
  templateUrl: './most-reviewed.component.html',
  styleUrls: ['./most-reviewed.component.css']
})
export class MostReviewedComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  index: number = 0;
  size: number = 10;
  // payload:;
  mostReviewed:any ; 
  dataSource = new MatTableDataSource<any>([])
  dataLength :number =0 ;
  data:any ={}; 
  isLoading:boolean=false




  displayColumns: string[] = ["coustomer", "entityName", "comment","createdOn","status","Actions" ]

  constructor( private httpClient: HttpClient ,     private snotifyService: ToastrService,    private reviewsService: ReviewsService,

    ) { }

  ngOnInit() {
    this.getMostRevieewedITem();

  }



  getMostRevieewedITem(){
   let  data ={
    pagination: {  start: this.index, number: this.size },

    search: {
      predicateObject: {
        Status: 1,
        EntityType:1
      }
    },
      sort: {
      }
    } 
    this.httpClient.post(`/ReplyApi/grid`,data).subscribe( (res:any)=>{
      this.dataSource=res.data; 
      this.dataLength = res.totalCount;

     console.log(this.dataSource)
     this.isLoading=true;
    })
    err=>{
      console.log(err.message)
    }
  }


  changePage(event) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getMostRevieewedITem()
  }


  openNotifyError(message: string) {
    this.snotifyService.error(message, "", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifySuccess(message: any) {
    this.snotifyService.success(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }


  changeStatus(id,status){
    this.reviewsService.changeStatusReply(id,status).subscribe((res)=>{
      this.getMostRevieewedITem()
      this.openNotifySuccess("The status has been changed")
    },err=>{
      this.openNotifyError('Somthing went wrong')
    })
  }



}
